import { create } from "zustand";

export const useAuthModalStore = create((set) => ({
  isOpen: false,
  mode: "login", // "login" | "register"
  referralCode: "",

  openLogin: () => set({ isOpen: true, mode: "login" }),
  openRegister: (referralCode = "") => set({ isOpen: true, mode: "register", referralCode }),
  close: () => set({ isOpen: false }),
  switchToLogin: () => set({ mode: "login" }),
  switchToRegister: () => set({ mode: "register" }),
}));
